// GOES X-ray flare class boundaries (W/m²) at each log₁₀ decade.
// A: 1e-8–1e-7, B: 1e-7–1e-6, C: 1e-6–1e-5, M: 1e-5–1e-4, X: ≥1e-4
export const XRAY_FLARE_CLASS_LEVELS = [
  { label: 'A', value: 1e-8 },
  { label: 'B', value: 1e-7 },
  { label: 'C', value: 1e-6 },
  { label: 'M', value: 1e-5 },
  { label: 'X1', value: 1e-4 },
  { label: 'X10', value: 1e-3 },
];

// NOAA Radio Blackout (R-scale) bands vs GOES 0.1–0.8 nm X-ray flux (W/m²).
export const XRAY_R_SCALE_QUIET_COLOR = '#92D050';
export const XRAY_R_SCALE_LEVELS = [
  { level: 1, label: 'R1', value: 1e-5, minBound: 1e-5, maxBound: 5e-5, color: '#FFE800' },
  { level: 2, label: 'R2', value: 5e-5, minBound: 5e-5, maxBound: 1e-4, color: '#FFCC33' },
  { level: 3, label: 'R3', value: 1e-4, minBound: 1e-4, maxBound: 1e-3, color: '#FF8C00' },
  { level: 4, label: 'R4', value: 1e-3, minBound: 1e-3, maxBound: 2e-3, color: '#FF3333' },
  { level: 5, label: 'R5', value: 2e-3, minBound: 2e-3, maxBound: Infinity, color: '#FF0000' },
];

/** Stacked side-bar bands for an X-ray Y domain (quiet below R1, then R1–R5). */
export const buildXrayRScaleBands = (levels, yDomain) => {
  if (!Array.isArray(yDomain) || yDomain.length < 2 || !levels.length) return [];

  const ymin = Math.min(yDomain[0], yDomain[1]);
  const ymax = Math.max(yDomain[0], yDomain[1]);
  const bands = [];

  const r1 = levels[0];
  if (r1 && ymin < r1.value) {
    bands.push({
      label: '',
      color: XRAY_R_SCALE_QUIET_COLOR,
      lo: ymin,
      hi: Math.min(r1.value, ymax),
    });
  }

  levels.forEach((r) => {
    const lo = Math.max(r.minBound, ymin);
    const hiRaw = r.maxBound === Infinity ? ymax : r.maxBound;
    const hi = Math.min(hiRaw, ymax);
    if (hi > lo) {
      bands.push({ label: r.label, color: r.color, lo, hi });
    }
  });

  return bands;
};

export const formatLog10Tick = (d) => {
  if (!(d > 0)) return '';
  const exp = Math.round(Math.log10(d));
  const digits = '⁰¹²³⁴⁵⁶⁷⁸⁹';
  const expStr = String(exp)
    .split('')
    .map((c) => (c === '-' ? '⁻' : digits[+c]))
    .join('');
  return `10${expStr}`;
};

/** Powers of 10 within [min, max] for log-axis decade ticks / gridlines. */
export const log10DecadeTicks = (min, max) => {
  if (!(min > 0) || !(max > 0) || min > max) return [];
  const start = Math.ceil(Math.log10(min) - 1e-12);
  const end = Math.floor(Math.log10(max) + 1e-12);
  const ticks = [];
  for (let e = start; e <= end; e += 1) ticks.push(10 ** e);
  return ticks;
};
